export type TimeType = 'seconds' | 'minutes' | 'hours' | 'days' | 'months' | 'years';

export const SECONDS: TimeType = 'seconds';
export const MINUTES: TimeType = 'minutes';
export const HOURS: TimeType = 'hours';
export const DAYS: TimeType = 'days';
export const MONTHS: TimeType = 'months';
export const YEARS: TimeType = 'years';
